import { get } from 'lodash';

import { API_NAME, FIELD_PATHS, REDUX_STORE } from '@funnels/constants';
import { CreditReportActionTypes, CreditReportsReducerState, SharedActionTypes } from '@funnels/types';

const initialState: CreditReportsReducerState = {
  data: [],
  error: null,
  loading: 0,
};

export default function creditReportsReducer(
  state: CreditReportsReducerState = initialState,
  action: CreditReportActionTypes | SharedActionTypes
): CreditReportsReducerState {
  switch (action.type) {
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    case REDUX_STORE.CREDIT_REPORTS.ACTION_TYPES.FETCH_CREDIT_REPORT:
    case REDUX_STORE.CREDIT_REPORTS.ACTION_TYPES.FETCH_CREDIT_REPORTS:
      return {
        ...state,
        loading: state.loading + 1,
      };
    case REDUX_STORE.CREDIT_REPORTS.ACTION_TYPES.FETCH_CREDIT_REPORT_SUCCESS:
      return {
        ...state,
        // partial replacement base on action applicantId
        data: [
          ...state.data.filter(
            (creditReport) =>
              get({ creditReports: [creditReport] }, FIELD_PATHS.CREDIT_REPORT_APPLICANT_ID(0)) !== action.applicantId
          ),
          { ...action.creditReport, applicantId: action.applicantId },
        ],
        loading: state.loading - 1,
      };

    case REDUX_STORE.CREDIT_REPORTS.ACTION_TYPES.FETCH_CREDIT_REPORT_FAIL:
      return {
        ...state,
        loading: state.loading - 1,
        error: {
          name: API_NAME.CREDIT_REPORTS,
          message: action.message,
        },
      };
    case REDUX_STORE.CREDIT_REPORTS.ACTION_TYPES.FETCH_CREDIT_REPORTS_SUCCESS:
    case REDUX_STORE.CREDIT_REPORTS.ACTION_TYPES.FETCH_CREDIT_REPORTS_FAIL:
      return {
        ...state,
        loading: state.loading - 1,
      };
    default:
      return state;
  }
}
